import React, { Component } from 'react';

import { Headers } from '../header.component';
import { InternalDataTable, InternalDataTableGrid } from '../Invoice/invoice-table.component';
import { ChartHeaderDropdown } from '../../common/data-header/chart-header-dropdown.component';
import { StatusData } from '../status-data.component';
import './quotation-component.css';
import ManageQuotation from './manage-quotation/manage-quotation.component';
import { Table_View } from '../../../constants/internal-constants';

class Quotation extends Component {
	constructor(props) {
        super(props);
        this.state={
            pageNumber:0,
			viewType:Table_View.List,
			viewDetailPage:false			
        }	
      }

	  getData=(value)=>{
		this.setState({viewDetailPage:value})
	  }

    render() {
		const data = {
			"orderTaskData": [{
				"OrderID": 12860,
				"Status": "Rejected",
				"OrderNumber": "TEM2021111112860",
				"OrderType": "Simple",
				"RequestTypeID": 27,
				"Requestor": "aili.a.suddock@email.com",
				"CircuitCode": null,
				"AssignedTo": "",
				"RequestDate": "11/11/2021",
				"RequestDetails": null,
				"OrderStatus": "Approved",
				"RequestType": "New Circuit",
				"EndUser": "aili.a.suddock@email.com",
				"VendorName": "Globe (PH)",
				"LastUpdated": "11/11/2021",
				"SubmittedDate": "",
				"ApprovedDate": "11/09/2021",
				"Country": "Philippines",
				"BadgeId": 1
			}, {
				"OrderID": 12858,
				"Status": "Open",
				"OrderNumber": "TEM2021110912858",
				"OrderType": "Simple",
				"RequestTypeID": 27,
				"Requestor": "aili.a.suddock@email.com",
				"CircuitCode": null,
				"AssignedTo": "",
				"RequestDate": "11/11/2021",
				"RequestDetails": null,
				"OrderStatus": "Approved",
				"RequestType": "New Circuit",
				"EndUser": "aili.a.suddock@email.com",
				"VendorName": "Globe (PH)",
				"LastUpdated": "11/09/2021",
				"SubmittedDate": "",
				"ApprovedDate": "11/09/2021",
				"Country": "Philippines",
				"BadgeId": 1
			}, {
				"OrderID": 12857,
				"Status": "Open",
				"OrderNumber": "TEM2021110912857",
				"OrderType": "Simple",
				"RequestTypeID": 27,
				"Requestor": "sample@email.com",
				"CircuitCode": null,
				"AssignedTo": "",
				"RequestDate": "11/11/2021",
				"RequestDetails": null,
				"OrderStatus": "Approved",
				"RequestType": "New Circuit",
				"EndUser": "sample@email.com",
				"VendorName": "Globe (PH)",
				"LastUpdated": "11/09/2021",
				"SubmittedDate": "",
				"ApprovedDate": "11/09/2021",
				"Country": "Philippines",
				"BadgeId": 1
			}, {
				"OrderID": 12856,
				"Status": "Open",
				"OrderNumber": "TEM2021110912856",
				"OrderType": "Simple",
				"RequestTypeID": 27,
				"Requestor": "aili.a.suddock@email.com",
				"CircuitCode": null,
				"AssignedTo": "",
				"RequestDate": "11/11/2021",
				"RequestDetails": null,
				"OrderStatus": "Approved",
				"RequestType": "New Circuit",
				"EndUser": "aili.a.suddock@email.com",
				"VendorName": "Claro - fAlu (AR)",
				"LastUpdated": "11/09/2021",
				"SubmittedDate": "",
				"ApprovedDate": "11/09/2021",
				"Country": "Argentina",
				"BadgeId": 1
			}, {
				"OrderID": 12854,
				"Status": "Open",
				"OrderNumber": "TEM2021110912854",
				"OrderType": "Simple",
				"RequestTypeID": 27,
				"Requestor": "aili.a.suddock@email.com",
				"CircuitCode": null,
				"AssignedTo": "",
				"RequestDate": "11/11/2021",
				"RequestDetails": null,
				"OrderStatus": "Approved",
				"RequestType": "New Circuit",
				"EndUser": "aili.a.suddock@email.com",
				"VendorName": "Globe (PH)",
				"LastUpdated": "11/09/2021",
				"SubmittedDate": "",
				"ApprovedDate": "11/09/2021",
				"Country": "Philippines",
				"BadgeId": 1
			}, {
				"OrderID": 12855,
				"Status": "Open",
				"OrderNumber": "TEM2021110912854",
				"OrderType": "Simple",
				"RequestTypeID": 27,
				"Requestor": "aili.a.suddock@email.com",
				"CircuitCode": null,
				"AssignedTo": "",
				"RequestDate": "11/11/2021",
				"RequestDetails": null,
				"OrderStatus": "Approved",
				"RequestType": "New Circuit",
				"EndUser": "aili.a.suddock@email.com",
				"VendorName": "Globe (PH)",
				"LastUpdated": "11/09/2021",
				"SubmittedDate": "",
				"ApprovedDate": "11/09/2021",
				"Country": "Philippines",
				"BadgeId": 1
			}, {
				"OrderID": 12856,
				"Status": "Open",
				"OrderNumber": "TEM2021110912854",
				"OrderType": "Simple",
				"RequestTypeID": 27,
				"Requestor": "aili.a.suddock@email.com",
				"CircuitCode": null,
				"AssignedTo": "",
				"RequestDate": "11/11/2021",
				"RequestDetails": null,
				"OrderStatus": "Approved",
				"RequestType": "New Circuit",
				"EndUser": "aili.a.suddock@email.com",
				"VendorName": "Globe (PH)",
				"LastUpdated": "11/09/2021",
				"SubmittedDate": "",
				"ApprovedDate": "11/09/2021",
				"Country": "Philippines",
				"BadgeId": 1
			}, {
				"OrderID": 12857,
				"Status": "Open",
				"OrderNumber": "TEM2021110912854",
				"OrderType": "Simple",
				"RequestTypeID": 27,
				"Requestor": "aili.a.suddock@email.com",
				"CircuitCode": null,
				"AssignedTo": "",
				"RequestDate": "11/11/2021",
				"RequestDetails": null,
				"OrderStatus": "Approved",
				"RequestType": "New Circuit",
				"EndUser": "aili.a.suddock@email.com",
				"VendorName": "Globe (PH)",
				"LastUpdated": "11/09/2021",
				"SubmittedDate": "",
				"ApprovedDate": "11/09/2021",
				"Country": "Philippines",
				"BadgeId": 1
			}, {
				"OrderID": 12859,
				"Status": "Open",
				"OrderNumber": "TEM2021110912854",
				"OrderType": "Simple",
				"RequestTypeID": 27,
				"Requestor": "aili.a.suddock@email.com",
				"CircuitCode": null,
				"AssignedTo": "",
				"RequestDate": "11/11/2021",
				"RequestDetails": null,
				"OrderStatus": "Approved",
				"RequestType": "New Circuit",
				"EndUser": "aili.a.suddock@email.com",
				"VendorName": "Globe (PH)",
				"LastUpdated": "11/09/2021",
				"SubmittedDate": "",
				"ApprovedDate": "11/09/2021",
				"Country": "Philippines",
				"BadgeId": 1
			}, {
				"OrderID": 12860,
				"Status": "Open",
				"OrderNumber": "TEM2021110912854",
				"OrderType": "Simple",
				"RequestTypeID": 27,
				"Requestor": "aili.a.suddock@email.com",
				"CircuitCode": null,
				"AssignedTo": "",
				"RequestDate": "11/11/2021",
				"RequestDetails": null,
				"OrderStatus": "Approved",
				"RequestType": "New Circuit",
				"EndUser": "aili.a.suddock@email.com",
				"VendorName": "Globe (PH)",
				"LastUpdated": "11/09/2021",
				"SubmittedDate": "",
				"ApprovedDate": "11/09/2021",
				"Country": "Philippines",
				"BadgeId": 1
			}, {
				"OrderID": 12861,
				"Status": "Closed",
				"OrderNumber": "TEM2021110912854",
				"OrderType": "Simple",
				"RequestTypeID": 27,
				"Requestor": "aili.a.suddock@email.com",
				"CircuitCode": null,
				"AssignedTo": "",
				"RequestDate": "11/11/2021",
				"RequestDetails": null,
				"OrderStatus": "Approved",
				"RequestType": "New Circuit",
				"EndUser": "aili.a.suddock@email.com",
				"VendorName": "Globe (PH)",
				"LastUpdated": "11/09/2021",
				"SubmittedDate": "",
				"ApprovedDate": "11/09/2021",
				"Country": "Philippines",
				"BadgeId": 1
			}, {
				"OrderID": 12862,
				"Status": "In Progress",
				"OrderNumber": "TEM2021110912854",
				"OrderType": "Simple",
				"RequestTypeID": 27,
				"Requestor": "aili.a.suddock@email.com",
				"CircuitCode": null,
				"AssignedTo": "",
				"RequestDate": "11/11/2021",
				"RequestDetails": null,
				"OrderStatus": "Approved",
				"RequestType": "New Circuit",
				"EndUser": "aili.a.suddock@email.com",
				"VendorName": "Globe (PH)",
				"LastUpdated": "11/09/2021",
				"SubmittedDate": "",
				"ApprovedDate": "11/09/2021",
				"Country": "Philippines",
				"BadgeId": 1
			}],
			"orderTaskDataPageCount": 245
		};

		const dataHeader=[
			"",
            "TEM Service Req",
            "Request Type",
            "Requestor Email",
            "Assigned To",
            "Vendor Name",
            "Last Updated",
            "Submitted Date",
			"Request Date",
            "Approved Date",
            "Country"
            ];

		const pages={
			HasNext: true,
			HasPrevious: false,
			PageNumber: this.state.pageNumber,
			PerPage: 12,
			TotalEntries: 12,
			TotalPages: 1
		}
		const dropdownItem=[
            "Invoice Number", "Item 2", "Item 3"
        ]; 
		
        const ledger=[
            {"Total":13525, "Open":1100,"In Progress": 2009,"Closed":200,"Failed":50,"KPI LABEL":20,"KPI LABEL":30}
        ]

		const tableView = () => {
			if (this.state.viewType == Table_View.List ) {				
				return <InternalDataTable pages={pages} getData={this.getData} dataHeader={dataHeader} dataTable={data.orderTaskData} statusData={ledger} page="order"/>;
			} else {
				
				return <InternalDataTableGrid pages={pages} dataTable={data.orderTaskData} statusData={ledger} page="order"/>;
			}
		}			
 
		const renderView=(value)=>{
			this.setState({viewType: value})
		}

        return (
            <div>
               <Headers title="Quotation" />
			   {
				this.state.viewDetailPage ? 
					<ManageQuotation closeForm={this.getData.bind(this)}/> 
					
					:

					<div className="request-table data-table request-table-invoice fit-width">
				   	<StatusData data={ledger} />
					<ChartHeaderDropdown haveOneIcone={false} haveIconInfo={false} iconInfo="info-circle-solid" haveLedger={true} ledger={ledger} headerName="Tasks" circleIcon={true} circleFirstIcon="list-regular" circleSecondIcon="th-solid" oneIcon="vertical-grid" 
						haveInput={true} haveDropdown={true} dropdownItem={dropdownItem} viewType={renderView} />
					{tableView()}
					
			   </div>
			   }			   			  			  
            </div>
        )
    }
}

export default Quotation;